var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDyblicateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.875 2.5H5.625C5.27982 2.5 5 2.77982 5 3.125C5 3.47018 5.27982 3.75 5.625 3.75H16.25V14.375C16.25 14.7202 16.5298 15 16.875 15C17.2202 15 17.5 14.7202 17.5 14.375V3.125C17.5 2.77982 17.2202 2.5 16.875 2.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.5 16.875V5.625C2.5 5.27982 2.77982 5 3.125 5H14.375C14.7202 5 15 5.27982 15 5.625V16.875C15 17.2202 14.7202 17.5 14.375 17.5H3.125C2.77982 17.5 2.5 17.2202 2.5 16.875ZM13.75 16.25H3.75V6.25H13.75V16.25Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDyblicateIcon);
export default __webpack_public_path__ + "static/media/dyblicateIcon.760d8b09da60e53e3c489bee628c6c59.svg";
export { ForwardRef as ReactComponent };